/**
 * Maps Supabase error codes/messages to user-friendly error messages.
 */
export function getAuthErrorMessage(
  errorCode: string | null,
  errorDescription: string | null
): string {
  switch (errorCode) {
    case 'otp_expired':
      return 'This link has expired. Please request a new one.'
    case 'otp_disabled':
      return 'Email links are currently disabled. Please try another sign-in method.'
    case 'validation_failed':
      return 'The link is invalid. Please request a new one.'
    case 'user_not_found':
      return 'No account found with this email address.'
    case 'user_banned':
      return 'This account has been suspended. Please contact support.'
    case 'email_not_confirmed':
      return 'Please confirm your email address first.'
    case 'access_denied':
      if (errorDescription?.includes('expired')) {
        return 'This link has expired. Please request a new one.'
      }
      return 'Access denied. The link may be invalid or has already been used.'
    default:
      if (errorDescription) {
        return decodeURIComponent(errorDescription.replace(/\+/g, ' '))
      }
      return 'Something went wrong. Please try again.'
  }
}

/**
 * Extracts error code and description from a Supabase AuthError.
 * Supabase errors may have the code in the message or as a separate property.
 */
export function getAuthErrorMessageFromError(error: Error): string {
  const message = error.message.toLowerCase()

  // Try to match known error patterns in the message
  if (message.includes('otp_expired') || message.includes('expired')) {
    return getAuthErrorMessage('otp_expired', null)
  }
  if (message.includes('validation_failed') || message.includes('invalid')) {
    return getAuthErrorMessage('validation_failed', null)
  }
  if (message.includes('user_not_found') || message.includes('not found')) {
    return getAuthErrorMessage('user_not_found', null)
  }
  if (message.includes('already') || message.includes('used')) {
    return getAuthErrorMessage('access_denied', null)
  }

  return getAuthErrorMessage(null, error.message)
}
